import userService from '@/services/UserService';

const users = {
  state: {
    userList: [],
  },
  getters: {
    users(state) {
      return state.userList;
    },
  },
  mutations: {
    SET_USER_LIST(state, payload) {
      state.userList = [...payload];
    },
  },
  actions: {
    getUsers({ commit }) {
      userService.getUsers()
        .then((response) => {
          commit('SET_USER_LIST', response.data);
        });
    },
  },
};

export default users;



// WEBPACK FOOTER //
// ./src/vuex/setting/users.js